import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { plantNcuDetailRoute } from "@/pages/PlantNcuDetail/route";

export const plantHsuDetailRoute = createRoute({
  path: "hsu/$hsuName",
  getParentRoute: () => plantNcuDetailRoute,
  staticData: { crumb: "hsu" },
  // Fuerza un remount completo al cambiar de HSU: el SSE de useSSE no resetea
  // su último dato al reconectar, así que sin esto el chip podía arrastrar un
  // instante el estado de la HSU anterior.
  remountDeps: ({ params }) => params.hsuName,
  component: lazyRouteComponent(async () => {
    const m = await import("./GuardedPlantHsuDetail");
    return { default: m.GuardedPlantHsuDetail };
  }),
});
